module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"type":{"image":"Image","audio":"Audio","video":"Video","file":"Data File"},"replace":"Replace","notUploaded":{"text":"Not yet uploaded","title":"To upload files, drag and drop one or more files onto this page"}}}')
  delete Component.options._Ctor
}
